"use strict";function faceManager$(a){return ddSdk_1.ddSdk.invokeAPI(apiName,a)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.faceManager$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.ATMBle.faceManager";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.0.7"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.0.7"},_a)),exports.faceManager$=faceManager$,exports.default=faceManager$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/ATMBle/faceManager.js
// module id = 903
// module chunks = 106